// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file bridge/bridge.proto (package lvdr.v2.bridge, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bridge/bridge.proto.
 */
export const file_bridge_bridge: GenFile = /*@__PURE__*/
  fileDesc("ChNicmlkZ2UvYnJpZGdlLnByb3RvEg5sdmRyLnYyLmJyaWRnZSIlChdCcmlkZ2VSZXF1ZXN0R2V0UmVxdWVzdBIKCgJpZBgBIAEoCSK7AgoYQnJpZGdlUmVxdWVzdEdldFJlc3BvbnNlEgoKAmlkGAEgASgJEgwKBG5lZWQYAiABKAkSQAoEaGludBgDIAMoCzIyLmx2ZHIudjIuYnJpZGdlLkJyaWRnZVJlcXVlc3RHZXRSZXNwb25zZS5IaW50RW50cnkSDwoHZXhjZXJwdBgEIAEoCRIPCgdjaGFubmVsGAUgASgJEhEKCXJlcXVlc3RlchgGIAEoCRISCgpjcmVhdGVkX2F0GAcgASgJEhIKCmV4cGlyZXNfYXQYCCABKAkSDQoFc3RhdGUYCSABKAkSFAoMaG9sZGluZ19zZW50GAogASgIEhQKDGRlY2xpbmVfdGV4dBgLIAEoCRorCglIaW50RW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASJHChJCcmlkZ2VEcmFmdFJlcXVlc3QSCgoCaWQYASABKAkSDwoHc25pcHBldBgCIAEoCRIUCgxpbnN0cnVjdGlvbnMYAyABKAkiJAoTQnJpZGdlRHJhZnRSZXNwb25zZRINCgVyZXBseRgBIAEoCSKmAQoUQnJpZGdlUmVzb2x2ZVJlcXVlc3QSCgoCaWQYASABKAkSDgoGYWN0aW9uGAIgASgJEhsKE3NuaXBwZXRfc291cmNlX2tpbmQYAyABKAkSGQoRc25pcHBldF9zb3VyY2VfaWQYBCABKAkSFQoNc25pcHBldF9maWVsZBgFIAEoCRIUCgxzbmlwcGV0X3RleHQYBiABKAkSDQoFcmVwbHkYByABKAkiJgoVQnJpZGdlUmVzb2x2ZVJlc3BvbnNlEg0KBXN0YXRlGAEgASgJIlMKHEJyaWRnZVNldFNlbmRBcHByb3ZhbFJlcXVlc3QSEwoLd29ya2Zsb3dfaWQYASABKAkSDwoHc3RlcF9pZBgCIAEoCRINCgVhbGxvdxgDIAEoCCJUCh1CcmlkZ2VTZXRTZW5kQXBwcm92YWxSZXNwb25zZRITCgt3b3JrZmxvd19pZBgBIAEoCRIPCgdzdGVwX2lkGAIgASgJEg0KBWFsbG93GAMgASgIQidaJWdpdGh1Yi5jb20vZ3ZzNDIvbHZkci9wcm90by92Mi9icmlkZ2ViBnByb3RvMw");

/**
 * @generated from message lvdr.v2.bridge.BridgeRequestGetRequest
 */
export type BridgeRequestGetRequest = Message<"lvdr.v2.bridge.BridgeRequestGetRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message lvdr.v2.bridge.BridgeRequestGetRequest.
 * Use `create(BridgeRequestGetRequestSchema)` to create a new message.
 */
export const BridgeRequestGetRequestSchema: GenMessage<BridgeRequestGetRequest> = /*@__PURE__*/
  messageDesc(file_bridge_bridge, 0);

/**
 * @generated from message lvdr.v2.bridge.BridgeRequestGetResponse
 */
export type BridgeRequestGetResponse = Message<"lvdr.v2.bridge.BridgeRequestGetResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string need = 2;
   */
  need: string;

  /**
   * @generated from field: map<string, string> hint = 3;
   */
  hint: { [key: string]: string };

  /**
   * @generated from field: string excerpt = 4;
   */
  excerpt: string;

  /**
   * @generated from field: string channel = 5;
   */
  channel: string;

  /**
   * @generated from field: string requester = 6;
   */
  requester: string;

  /**
   * RFC 3339.
   *
   * @generated from field: string created_at = 7;
   */
  createdAt: string;

  /**
   * @generated from field: string expires_at = 8;
   */
  expiresAt: string;

  /**
   * open | resolving | expiring | released | answered | declined | expired | closed
   *
   * @generated from field: string state = 9;
   */
  state: string;

  /**
   * @generated from field: bool holding_sent = 10;
   */
  holdingSent: boolean;

  /**
   * @generated from field: string decline_text = 11;
   */
  declineText: string;
};

/**
 * Describes the message lvdr.v2.bridge.BridgeRequestGetResponse.
 * Use `create(BridgeRequestGetResponseSchema)` to create a new message.
 */
export const BridgeRequestGetResponseSchema: GenMessage<BridgeRequestGetResponse> = /*@__PURE__*/
  messageDesc(file_bridge_bridge, 1);

/**
 * @generated from message lvdr.v2.bridge.BridgeDraftRequest
 */
export type BridgeDraftRequest = Message<"lvdr.v2.bridge.BridgeDraftRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string snippet = 2;
   */
  snippet: string;

  /**
   * @generated from field: string instructions = 3;
   */
  instructions: string;
};

/**
 * Describes the message lvdr.v2.bridge.BridgeDraftRequest.
 * Use `create(BridgeDraftRequestSchema)` to create a new message.
 */
export const BridgeDraftRequestSchema: GenMessage<BridgeDraftRequest> = /*@__PURE__*/
  messageDesc(file_bridge_bridge, 2);

/**
 * @generated from message lvdr.v2.bridge.BridgeDraftResponse
 */
export type BridgeDraftResponse = Message<"lvdr.v2.bridge.BridgeDraftResponse"> & {
  /**
   * @generated from field: string reply = 1;
   */
  reply: string;
};

/**
 * Describes the message lvdr.v2.bridge.BridgeDraftResponse.
 * Use `create(BridgeDraftResponseSchema)` to create a new message.
 */
export const BridgeDraftResponseSchema: GenMessage<BridgeDraftResponse> = /*@__PURE__*/
  messageDesc(file_bridge_bridge, 3);

/**
 * @generated from message lvdr.v2.bridge.BridgeResolveRequest
 */
export type BridgeResolveRequest = Message<"lvdr.v2.bridge.BridgeResolveRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * release | answer | decline
   *
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * Where the released snippet came from (release only): note | document.
   *
   * @generated from field: string snippet_source_kind = 3;
   */
  snippetSourceKind: string;

  /**
   * @generated from field: string snippet_source_id = 4;
   */
  snippetSourceId: string;

  /**
   * @generated from field: string snippet_field = 5;
   */
  snippetField: string;

  /**
   * The exact released text (release only). Pinned: stored and sent as is.
   *
   * @generated from field: string snippet_text = 6;
   */
  snippetText: string;

  /**
   * The exact reply text (release, answer). Pinned: sent as is.
   *
   * @generated from field: string reply = 7;
   */
  reply: string;
};

/**
 * Describes the message lvdr.v2.bridge.BridgeResolveRequest.
 * Use `create(BridgeResolveRequestSchema)` to create a new message.
 */
export const BridgeResolveRequestSchema: GenMessage<BridgeResolveRequest> = /*@__PURE__*/
  messageDesc(file_bridge_bridge, 4);

/**
 * @generated from message lvdr.v2.bridge.BridgeResolveResponse
 */
export type BridgeResolveResponse = Message<"lvdr.v2.bridge.BridgeResolveResponse"> & {
  /**
   * @generated from field: string state = 1;
   */
  state: string;
};

/**
 * Describes the message lvdr.v2.bridge.BridgeResolveResponse.
 * Use `create(BridgeResolveResponseSchema)` to create a new message.
 */
export const BridgeResolveResponseSchema: GenMessage<BridgeResolveResponse> = /*@__PURE__*/
  messageDesc(file_bridge_bridge, 5);

/**
 * Arms (or disarms) send-gate key 1 on one bridge step of the live spec, so the
 * holding and fallback replies may send unattended once account key 2 is on.
 * A dedicated request, never the save body: a deployed workflow's save goes to
 * the draft, and an absent field must not disarm (AON-11 CARRIED-1).
 *
 * @generated from message lvdr.v2.bridge.BridgeSetSendApprovalRequest
 */
export type BridgeSetSendApprovalRequest = Message<"lvdr.v2.bridge.BridgeSetSendApprovalRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string step_id = 2;
   */
  stepId: string;

  /**
   * @generated from field: bool allow = 3;
   */
  allow: boolean;
};

/**
 * Describes the message lvdr.v2.bridge.BridgeSetSendApprovalRequest.
 * Use `create(BridgeSetSendApprovalRequestSchema)` to create a new message.
 */
export const BridgeSetSendApprovalRequestSchema: GenMessage<BridgeSetSendApprovalRequest> = /*@__PURE__*/
  messageDesc(file_bridge_bridge, 6);

/**
 * @generated from message lvdr.v2.bridge.BridgeSetSendApprovalResponse
 */
export type BridgeSetSendApprovalResponse = Message<"lvdr.v2.bridge.BridgeSetSendApprovalResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string step_id = 2;
   */
  stepId: string;

  /**
   * The armed state now stored on the live spec.
   *
   * @generated from field: bool allow = 3;
   */
  allow: boolean;
};

/**
 * Describes the message lvdr.v2.bridge.BridgeSetSendApprovalResponse.
 * Use `create(BridgeSetSendApprovalResponseSchema)` to create a new message.
 */
export const BridgeSetSendApprovalResponseSchema: GenMessage<BridgeSetSendApprovalResponse> = /*@__PURE__*/
  messageDesc(file_bridge_bridge, 7);

